var _rect, _rect2, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSantillana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 257,
    viewBox: "0 0 256 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    transform: "translate(0 0.589844)",
    fill: "#F9F8F4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_1712)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 51.2,
    transform: "translate(20 102.59)",
    fill: "#F9F8F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.11 147.193H153.7V132.618C153.7 129.895 148.721 130.815 148.721 130.815V148.819C148.721 151.154 151.086 152.025 156.627 151.433C162.635 150.792 162.359 148.812 162.11 147.193ZM140.366 130.816V149.568C140.366 152.291 145.345 151.371 145.345 151.371V151.371V132.619C145.345 129.896 140.366 130.816 140.366 130.816ZM138.285 130.751H124.891C121.781 130.751 122.59 135.234 122.59 135.234H122.591H127.944V149.568C127.944 152.291 132.941 151.371 132.941 151.371V151.371V135.234H135.984C139.281 135.234 138.285 130.751 138.285 130.751ZM183.764 142.809L185.847 137.242L187.81 142.809H183.764ZM188.64 131.972C187.662 129.525 183.501 130.817 183.501 130.817L175.947 149.607C174.971 152.256 180.56 151.371 180.56 151.371L182.094 147.272H189.384L190.196 149.573C191.294 152.448 196.18 151.371 196.18 151.371L188.64 131.972ZM227.629 142.809L225.665 137.242L223.583 142.809H227.629ZM236 151.371C236 151.371 231.112 152.448 230.015 149.573L229.204 147.272H221.913L220.38 151.371C220.38 151.371 214.79 152.256 215.767 149.607L223.321 130.817C223.321 130.817 227.482 129.525 228.46 131.972L236 151.371ZM89.764 142.809L91.8465 137.242L93.8103 142.809H89.764ZM94.6399 131.972C93.6622 129.525 89.5012 130.817 89.5012 130.817L81.9473 149.607C80.9702 152.256 86.5603 151.371 86.5603 151.371L88.0939 147.272H95.3843L96.1953 149.573C97.2933 152.448 102.18 151.371 102.18 151.371L94.6399 131.972ZM209.596 130.816V143.336L202.955 132.619C202.287 131.542 201.193 131.036 200.114 130.816C199.625 130.703 199.092 130.666 198.6 130.668C197.605 130.661 196.858 130.816 196.858 130.816V149.568C196.858 152.291 201.837 151.371 201.837 151.371V151.371V138.851L208.479 149.568C209.147 150.646 210.24 151.152 211.319 151.371C211.809 151.485 212.342 151.522 212.835 151.52C213.83 151.527 214.576 151.371 214.576 151.371V151.371V132.619C214.576 129.896 209.596 130.816 209.596 130.816ZM115.844 130.816V143.336L109.202 132.619C108.534 131.542 107.44 131.036 106.362 130.816C105.871 130.703 105.339 130.666 104.847 130.668C103.851 130.661 103.106 130.816 103.106 130.816V149.568C103.106 152.291 108.085 151.371 108.085 151.371V151.371V138.851L114.727 149.568C115.394 150.646 116.488 151.152 117.566 151.371C118.056 151.485 118.589 151.522 119.082 151.52C120.076 151.527 120.823 151.371 120.823 151.371V151.371V132.619C120.823 129.896 115.844 130.816 115.844 130.816ZM64.8801 150.058C64.8801 150.058 65.2433 146.274 68.6487 146.848C72.4266 147.485 76.8989 148.043 76.7572 145.559C76.6082 142.95 65.8184 143.152 65.7517 136.226C65.6652 127.18 81.3122 131.628 81.3122 131.628C81.3122 131.628 81.4141 135.426 78.1036 135.206C75.5721 135.038 70.8498 134.257 70.7295 136.139C70.5766 138.526 82.037 138.862 81.735 145.444C81.2564 155.879 64.8801 150.058 64.8801 150.058ZM175.523 147.203L168.4 147.18V141.468V132.616C168.4 129.894 163.418 130.816 163.418 130.816V148.819C163.418 150.744 165.057 151.967 170.037 151.434C176.05 150.794 175.771 148.819 175.523 147.203Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 102,
    width: 49,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7533 102.588C47.4565 102.588 47.2029 102.59 47.0147 102.594C45.2763 102.594 42.4915 102.866 42.1369 102.909C40.2283 103.136 39.742 103.223 37.598 103.678C34.3234 104.372 29.5286 106.256 26.7412 108.747C25.5087 109.766 24.4357 111.07 24.0728 111.557C23.8164 111.9 23.4234 112.808 23.3336 113.238C23.1957 113.755 23.2118 114.435 23.2127 114.48H23.215C23.3172 114.366 27.2256 110.142 38.8123 110.543C38.8123 110.543 42.7281 109.388 49.6716 108.828C56.6251 108.267 64.2713 108.317 66.0992 108.333C67.0715 108.342 68.6417 108.356 69.8364 108.344C70.1323 108.341 70.3913 108.343 70.6135 108.345C71.253 108.349 71.5848 108.354 71.604 108.251C71.6178 108.176 71.5992 107.972 71.028 107.64C69.4383 106.715 66.5323 105.544 63.9004 104.807C61.92 104.186 58.4998 103.544 58.1991 103.492C55.1665 102.974 52.5959 102.772 51.1687 102.677C50.164 102.61 48.8785 102.589 47.938 102.588H47.7533Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.618 102.588H23.1959V114.48H71.618V102.588Z",
    fill: "url(#paint0_radial_371_1712)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 110,
    width: 37,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.236 114.525C23.236 114.525 22.7269 114.415 22.9269 115.889C23.1267 117.362 27.5826 123.889 27.5826 123.889C35.0499 119.254 53.316 117.526 56.8295 116.947C60.281 116.362 59.6992 113.149 44.4776 110.995C41.8941 110.659 39.5975 110.518 37.5597 110.518C26.7167 110.518 23.236 114.525 23.236 114.525Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2812 110.518H22.7271V123.889H60.2812V110.518Z",
    fill: "url(#paint1_radial_371_1712)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 113,
    width: 51,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2092 113.617C35.8918 114.229 27.3056 121.311 27.5175 121.509C27.7435 121.665 40.0547 130.43 43.0369 128.756C46.0198 127.083 54.2191 125.322 60.7513 124.929C66.9444 124.556 74.565 123.024 76.776 120.709C78.2919 119.121 76.6202 116.525 66.5501 114.804C61.2501 114.009 59.8473 113.905 56.1896 113.651C55.9463 113.638 55.7046 113.627 55.4641 113.617H51.2092Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.291 113.617H27.3047V130.43H78.291V113.617Z",
    fill: "url(#paint2_radial_371_1712)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 127,
    width: 29,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0468 127.457L32.5381 135.604L41.4855 137.725C45.04 135.386 53.7069 134.7 53.7069 134.7C54.2679 134.638 66.146 133.702 56.1699 129.243C51.4514 127.528 47.8017 127.119 45.3955 127.119C43.207 127.119 42.0468 127.457 42.0468 127.457Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.146 127.119H32.5381V137.725H66.146V127.119Z",
    fill: "url(#paint3_radial_371_1712)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 110,
    width: 16,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0908 114.608C22.936 114.82 23.6092 118.183 23.6092 118.183C29.2833 112.78 38.8619 110.539 38.8619 110.539C38.2371 110.513 37.6354 110.5 37.0542 110.5C26.8014 110.5 23.2517 114.389 23.0908 114.608Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8613 110.5H22.9354V118.183H38.8613V110.5Z",
    fill: "url(#paint4_linear_371_1712)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 113,
    width: 32,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9892 115.347C31.0886 117.762 27.4863 121.486 27.4863 121.486L28.7994 123.198C28.7994 123.198 32.2468 121.652 36.4687 120.516C41.3564 119.052 49.5018 117.921 50.7735 117.762C52.4058 117.557 56.5659 117.257 57.9754 116.555C60.3807 115.358 55.9013 113.641 55.9013 113.641C55.9013 113.641 54.8678 113.506 53.0281 113.506C50.2532 113.506 45.645 113.812 39.9892 115.347Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3802 113.506H27.4859V123.198H60.3802V113.506Z",
    fill: "url(#paint5_linear_371_1712)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4285 127.581C41.3686 127.54 42.4608 127.265 43.9646 127.139C44.974 127.055 46.1771 127.056 47.3123 127.174C47.3123 127.174 43.7988 128.176 43.6248 128.512C43.6248 128.512 41.3721 127.63 41.4285 127.581Z",
    fill: "#005A2F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3791 146.793C32.3791 146.793 33.655 147.348 35.1645 147.943C36.2618 148.375 37.5185 148.838 38.2022 149.22C38.2022 149.22 40.4216 150.312 38.8261 151.09C37.1604 151.901 34.7616 151.745 33.035 151.086C32.6243 150.944 32.1246 150.754 31.6007 150.473C30.9304 150.113 30.1925 149.672 29.4693 149.118C28.8278 148.626 28.2011 148.043 27.5853 147.38C25.683 145.334 24.1023 142.419 23.6715 141.481C23.2573 140.579 23.0117 139.553 23.0117 139.553L32.3791 146.793Z",
    fill: "#0095DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.34 143.865C40.34 143.865 42.7571 144.163 44.0073 144.614C44.4728 144.781 44.7725 145.076 44.6378 145.341C44.1756 146.246 40.6904 149.745 33.0855 147.071C33.0855 147.071 31.916 146.741 30.703 146.31C29.4896 145.88 24.3291 141.748 23.5527 140.629C22.7759 139.511 22.5233 138.957 21.9479 137.246C21.3353 135.424 20.6227 132.843 20.3457 130.367L20.6807 130.447L40.34 143.865Z",
    fill: "#86BD40"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0882 111.527C24.0882 111.527 23.7404 111.966 23.4772 112.747C23.1881 113.604 23.0275 114.865 23.6603 116.352C24.8839 119.227 29.7373 123.605 41.391 127.291C42.7473 127.692 43.7142 128.005 44.4012 128.453C46.0434 129.523 45.9354 130.745 44.063 132.116C41.7148 133.834 40.5405 134.509 37.3002 135.089C32.0381 136.032 26.6442 134.138 23.7385 131.719C21.6721 129.998 20.8874 128.525 20.4719 127.45C20.1109 126.515 20.0135 125.843 20.0135 125.8C20.0064 125.689 19.9689 124.123 20.2427 121.882C20.596 118.99 21.5077 114.973 24.0882 111.527Z",
    fill: "#DD006D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.362 125.739C20.362 125.739 29.8098 134.598 31.5739 134.962C32.1994 135.091 33.0338 135.227 34.3017 135.345C35.1473 135.424 36.2975 135.68 37.2205 135.862C38.1046 136.037 39.602 136.646 41.6071 137.287C43.9226 138.028 46.5144 138.595 47.764 138.741C48.0503 138.774 48.4074 138.841 48.753 138.857C49.8169 138.903 50.986 138.948 51.3855 139.982C51.8356 141.149 50.8979 142.458 49.9054 142.869C47.2117 143.986 44.9064 143.291 43.1946 144.389C43.1946 144.389 30.1827 142.829 22.4351 135.152C22.4351 135.152 20.48 132.894 20.2312 129.546C19.9831 126.21 20.0049 125.504 20.0049 125.504L20.362 125.739Z",
    fill: "#FFCC00"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2054 150.699C43.1027 150.699 41.706 151.471 41.2758 152.244C41.1825 152.411 41.1344 152.579 41.1351 152.738C41.1357 153.315 41.7634 153.788 43.1431 153.788C43.5454 153.788 44.0116 153.748 44.5443 153.658C45.5157 153.492 46.7489 152.946 47.3224 152.242C47.5327 151.983 47.6866 151.736 47.6859 151.516C47.685 151.216 47.3984 150.965 46.5787 150.802C46.0927 150.731 45.6346 150.699 45.2054 150.699Z",
    fill: "#0095DB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8116 118.846C20.8116 118.846 20.0788 123.581 26.0112 128.778C30.2822 132.519 36.1662 135.249 36.1662 135.249C36.1662 135.249 34.4582 135.444 32.2925 135.187C29.692 134.878 25.3486 133.769 22.19 130.261C20.3455 128.212 20.0114 125.779 20.0114 125.779C20.0114 125.779 19.8387 122.866 20.8359 118.615L20.8116 118.846Z",
    fill: "#DB0812"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3809 130.631C20.3809 130.631 21.4439 136.058 30.5824 140.282C37.3727 143.421 43.2019 144.383 43.2019 144.383C43.2019 144.383 41.334 144.513 38.7982 144.343C35.9163 144.148 32.6872 143.484 29.8588 142.253C26.2226 140.668 23.1833 138.072 21.5676 134.742C21.2137 134.013 20.8874 133.212 20.6838 132.42C20.6017 132.102 20.5424 131.703 20.4818 131.313C20.4466 131.087 20.4014 130.862 20.3809 130.631Z",
    fill: "#89A429"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_371_1712",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 102,
    width: 216,
    height: 52
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236 102.588H20V153.788H236V102.588Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_371_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3564 138.395C22.3564 138.395 22.8411 139.495 23.8413 140.736C24.5754 141.648 25.5961 142.676 26.9095 143.633C28.3091 144.653 30.2976 145.817 32.0668 146.619C33.738 147.376 35.117 147.925 35.117 147.925C35.117 147.925 34.0149 147.957 32.5711 147.696C31.0397 147.42 29.1621 146.803 27.7058 145.838C26.2905 144.9 25.0826 143.805 24.1177 142.234C23.1011 140.579 22.3564 138.395 22.3564 138.395Z",
    fill: "#008E4D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_371_1712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0444 103.248) scale(75.651 75.6721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD006D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4551,
    stopColor: "#DD006D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    stopColor: "#D8006C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5964,
    stopColor: "#CC0068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6859,
    stopColor: "#B80061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    stopColor: "#9C0056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8842,
    stopColor: "#790045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "#740042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#740042"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_371_1712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.3794 101.606) scale(85.7415 85.7654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4551,
    stopColor: "#FFCC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#FBC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6049,
    stopColor: "#EDBE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7016,
    stopColor: "#D8AC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#B99300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "#987900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#987900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_371_1712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0451 103.241) scale(75.6503 75.6714)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4551,
    stopColor: "#86BD40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    stopColor: "#7DB33E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6491,
    stopColor: "#679738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8318,
    stopColor: "#406829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "#2F5320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5320"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_371_1712",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0449 103.25) scale(75.6527 75.6738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4551,
    stopColor: "#009DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5127,
    stopColor: "#009BDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5884,
    stopColor: "#0092D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6742,
    stopColor: "#0085BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7667,
    stopColor: "#0072A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#005C86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_371_1712",
    x1: 23.0662,
    y1: 114.322,
    x2: 38.8603,
    y2: 114.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B0800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#6B0E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5917,
    stopColor: "#720F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7833,
    stopColor: "#841103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9503,
    stopColor: "#981108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9594,
    stopColor: "#9B1109"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9696,
    stopColor: "#A4110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9802,
    stopColor: "#B3110E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#C80F12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE0C15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_371_1712",
    x1: 27.4933,
    y1: 118.358,
    x2: 58.6922,
    y2: 118.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#293907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#37470E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4431,
    stopColor: "#596918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5525,
    stopColor: "#67761B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6627,
    stopColor: "#6F7F1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8867,
    stopColor: "#819725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89A429"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_1712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 51.2,
    fill: "white",
    transform: "translate(20 102.59)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantillana);
export default __webpack_public_path__ + "static/media/Santillana.6333ae8803cfc8103b6d37eee0270fe9.svg";
export { ForwardRef as ReactComponent };